export const PRODUCT_DATA = {
  name: 'Megapack Folclore Listo - Combo Completo',
  subtitle:
    'El sistema completo para llenar tus clases de folclore con contenidos listos para usar',
  paymentLink:
    'https://elrincondigital.click/checkouts/cn/hWNAn0jhzNOeXfBdra2WebQY/es-ar?_r=AQABt9lzd35DWdJ2YBMD7zWx3X_4W56rtBNMwco9uIj7aqI&preview_theme_id=154785841310',
  pixelId: '1322033292727002',
  mainImage:
    'https://cdn.magicpatterns.com/uploads/gihn2a9WHXm4WhuPZXVWjD/ChatGPT_Image_6_abr_2026,_10_44_10_p.m._(2).png',
  originalPrice: '$89.990',
  salePrice: '$19.990',
  savingsPercentage: '78%',
  totalValue: '$95.950',
  mainProductValue: '$49.990',
}

export const MAIN_PRODUCTS = [
  {
    title: 'Sistema de Inscripción por Whatsapp',
    description:
      'Convertí consultas en inscripciones sin perder el boca en boca',
  },
  {
    title: '20 Ideas de Contenido para Atraer Alumnos',
    description: 'Textos y videos listos para llenar tus clases de folclore',
  },
  {
    title: 'Marzo Lleno - Estrategia de 14 días',
    description: 'Para arrancar el año con más alumnos que nunca',
  },
  {
    title: 'Cómo Cobrar Mejor sin Perder Alumnos',
    description: 'Escalera de precios y cómo aumentar sin perder gente',
  },
  {
    title: 'Sistema Anti-Abandono de Invierno',
    description: 'Retén a tus alumnos cuando más te cuesta mantenerlos',
  },
]

export const BONUSES = [
  {
    title: 'PROFE DE FOLCLORE PROFESIONAL',
    description:
      'Guía completa de posicionamiento estratégico para profesores de folclore',
    value: '$14.990',
    image:
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=500',
  },
  {
    title: '20 IDEAS DE CONTENIDO EXTRA',
    description: 'Más textos y videos listos para redes sociales',
    value: '$9.990',
    image:
      'https://images.unsplash.com/photo-1611162617474-5b21e879e113?auto=format&fit=crop&q=80&w=500',
  },
  {
    title: 'CÓMO DIFERENCIARTE Y DEJAR DE COMPETIR',
    description: 'Posicionamiento claro para que te elijan sin dudarlo',
    value: '$12.990',
    image:
      'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=500',
  },
  {
    title: 'SCRIPTS DE VENTA POR WHATSAPP',
    description:
      'Mensajes probados para cerrar inscripciones sin parecer insistente',
    value: '$7.990',
    image:
      'https://images.unsplash.com/photo-1611262588024-d12430b98920?auto=format&fit=crop&q=80&w=500',
  },
]

export const TESTIMONIALS = [
  {
    name: 'Carolina Ramírez',
    age: 34,
    city: 'Córdoba, Argentina',
    text: 'Usé el Sistema Whatsapp y en dos semanas llené tres clases nuevas. Antes perdía el 80% de las consultas porque no sabía qué responder. Ahora tengo todo automatizado y funciona solo.',
  },
  {
    name: 'Miguel Sosa',
    age: 41,
    city: 'Salta, Argentina',
    text: 'El Sistema Anti-Abandono me salvó. Cada julio se me iban 15 alumnos. Este año solo perdí 2. La diferencia en mi cuenta bancaria es enorme. Mejor inversión que hice en años.',
  },
  {
    name: 'Lucía Pereyra',
    age: 29,
    city: 'Mendoza, Argentina',
    text: 'No tenía idea de qué publicar en Instagram. Con las 40 ideas de contenido ya listas, ahora publico 4 veces por semana y cada mes me llegan consultas nuevas. Es increíble.',
  },
  {
    name: 'Roberto Quintana',
    age: 38,
    city: 'Tucumán, Argentina',
    text: 'Subí mis precios 40% siguiendo la Escalera de Precios y no se fue nadie. Mis alumnos ahora entienden el valor de lo que ofrezco. Debí haberlo hecho hace años.',
  },
  {
    name: 'Valentina Castro',
    age: 31,
    city: 'Buenos Aires, Argentina',
    text: 'Marzo Lleno me dio 22 alumnos nuevos en 14 días. Nunca había arrancado el año así. El paso a paso es tan claro que solo tuve que seguirlo y funcionó perfecto.',
  },
]

export const FAQS = [
  {
    question: '¿Esto funciona si recién empiezo con mi academia?',
    answer:
      'Sí, de hecho es ideal para empezar bien desde el principio. Vas a tener todo el sistema armado desde el día uno, sin tener que inventar nada. Los profes que arrancan con este pack llenan sus clases 3 veces más rápido que los que van probando sin rumbo.',
  },
  {
    question: '¿Necesito saber de marketing o tecnología?',
    answer:
      'Para nada. Todo está explicado paso a paso, como si le estuvieras explicando a tu abuela. Si sabés usar Whatsapp e Instagram (aunque sea básico), ya tenés todo lo que necesitás. El 90% de nuestros profes no sabían nada de marketing antes de esto.',
  },
  {
    question: '¿Cuánto tiempo me va a tomar implementar todo?',
    answer:
      'Podés empezar a ver resultados en la primera semana. El Sistema Whatsapp lo configurás en 1 hora. Las ideas de contenido las empezás a publicar hoy mismo. Y el resto lo vas aplicando a tu ritmo, sin presión.',
  },
  {
    question: '¿Funciona para folclore de cualquier región?',
    answer:
      'Absolutamente. Las estrategias son las mismas seas de Salta, Córdoba, Buenos Aires o donde sea. Lo único que cambia es la danza, pero el sistema de llenado de clases es universal. Ya lo probaron profes de 12 provincias distintas.',
  },
  {
    question: '¿Y si no me funciona?',
    answer:
      'Tenés 45 días de garantía total. Si aplicás el sistema y no ves resultados, te devolvemos cada peso. Sin vueltas, sin preguntas. Pero honestamente, en 3 años nunca tuvimos que devolver ni un solo pago. Porque cuando se aplica, funciona.',
  },
]

export const POPUP_NAMES = [
  'Carolina R. - Córdoba',
  'Miguel S. - Salta',
  'Lucía P. - Mendoza',
  'Roberto Q. - Tucumán',
  'Valentina C. - Buenos Aires',
  'Diego M. - Rosario',
  'Jimena L. - San Juan',
  'Facundo B. - Neuquén',
  'Natalia F. - Entre Ríos',
  'Martín G. - Jujuy',
  'Sofía T. - Santa Fe',
  'Alejandro V. - La Rioja',
]
